export default {
  separator: '·',
  complement: 'Sitzungen',
}
